<template>
  <!-- 右侧悬浮 -->
  <div style="margin: 0; height:0px" v-if="this.flagA">
    <el-affix :offset="200">
      <div class="btn">
        <div
          v-for="fixed of fixedList"
          :key="fixed.id"
          class="btn_1"
          :style="{backgroundColor: (fixed.flag?'#2fb46c':'rgb(240,240,240)'),
                  borderRadius:(fixed.id ===1 ? '20px 0 0 0':'') || (fixed.id ===3 ? '0 0 0 20px':'')}"
          @mouseenter="yiru(fixed.id)"
          @mouseleave="yichu(fixed.id)"
        >
          <img :src="fixed.imgUrl" alt class="img" />
          {{fixed.title}}
        </div>
      </div>
    </el-affix>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fixedList: [
        {
          id: 1,
          flag: false,
          title: "立即入驻",
          imgUrl: "https://deiyustatic.oss-cn-beijing.aliyuncs.com/fixed/ruzhu.png",
        },
        {
          id: 2,
          flag: false,
          title: "在线客服",
          imgUrl: "https://deiyustatic.oss-cn-beijing.aliyuncs.com/fixed/kefu.png",
        },
        {
          id: 3,
          flag: false,
          title: "合作资讯",
          imgUrl: "https://deiyustatic.oss-cn-beijing.aliyuncs.com/fixed/hezuo.png",
        }
      ],
      flag1: false,
      flag2: false,
      flag3: false,
      width: window.innerWidth,
      flagA: false
    };
  },
  methods: {
    yiru(a) {
      if (a == 1) {
        this.fixedList[0].flag = true;
      } else if (a == 2) {
        this.fixedList[1].flag = true;
      } else if (a == 3) {
        this.fixedList[2].flag = true;
      }
    },
    yichu(a) {
      if (a == 1) {
        this.fixedList[0].flag = false;
      } else if (a == 2) {
        this.fixedList[1].flag = false;
      } else if (a == 3) {
        this.fixedList[2].flag = false;
      }
    },
    // 获取宽度
    updateWidth() {
      this.width = window.innerWidth;
      if (this.width < 599) {
        this.flagA = false
      } else {
        this.flagA = true
      }
    },
  },
  mounted() {
    // 获取宽度
    this.updateWidth();
    window.addEventListener('resize', this.updateWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);
  },
};
</script>

<style lang="less" scoped>
.btn {
  border-radius: 20px 0 0 20px;
  border: 1px rgb(210, 210, 210) solid;
  position: absolute;
  right: 0;

  .btn_1 {
    width: 40px;
    padding: 10px;
    text-align: center;

    .img {
      width: 35px;
      height: 35px;
    }
  }
}
</style>